module.exports = __webpack_public_path__ + "static/media/neighborhood.d1938347.svg";